import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'

import Toast from '@/components/Toast/index.js'
import MyAxios from './tools/myAxios.js'

import 'element-plus/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'

createApp(App)
    .use(router).use(ElementPlus).use(VueAxios, axios)
    .use(VueCookies).use(Toast).use(MyAxios).mount('#app');